import styled from "styled-components";

export const StyledWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1200;
`;
export const Styled = styled.div`
  & {
    max-width: 1200px;
    width: 100vw;
    height: calc(100vh - 100px);
    position: fixed;
    z-index: 1050;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 24px;
    padding-bottom: 52px;
    background: #fff;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3);
    .ant-spin-nested-loading {
      height: 100%;
      .ant-spin-container {
        height: 100%;
      }
    }
    .container-button-resize {
      position: absolute;
      bottom: 0px;
      left: -50px;
      z-index: 100;
      height: 60px;
      width: 100px;
      cursor: pointer;
      color: rgba(1, 68, 141, 1);
      &:hover {
        color: #007bff;
      }
      &.resizing {
        color: #007bff;
      }
      svg: {
        user-select: none;
      }
    }
    .iframe-overlay {
      position: absolute;
      width: 100vw;
      height: 100vh;
      z-index: 1700;
    }
  }
`;
